import React from 'react';

import type { Reference, Side } from '@swf/cms';
import { CMSReference, ContentType } from '@swf/cms';

import styles from './CMSSide.scss';

const CMSSide: React.FC<Side> = ({ body }) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {body.map((item, index) => {
      const [sideContent] = Object.values(item);
      return sideContent.reference.map((ref: Reference, index: number) => (
        <React.Fragment key={index}>
          {ref._content_type_uid === ContentType.SideRelatedContent && (
            <div className={styles.separator}></div>
          )}
          <CMSReference {...ref} />
        </React.Fragment>
      ));
    })}
  </>
);

export default CMSSide;
